import { createInstance } from '@/helpers/api/base'
import { useAppMutation } from '@/helpers/api/mutation'
import { ControlSheetAnnotationDTO } from '@/types/controlsheet'

interface ICreateDutyTimingAnnotationRequest {
    dutyCode: string
    tripNumber: string
    runNumber: string
    route: string
    identifier: string
    timingContextType: 'Departure' | 'Arrival' | undefined
    departureTime: string | undefined
    serviceNotOperated: boolean | undefined
}

export const useCreateTimingAnnotation = () => {
    const createTimingAnnotationMutation = useAppMutation<
        ControlSheetAnnotationDTO,
        Error,
        ICreateDutyTimingAnnotationRequest
    >({
        mutationFn: (data) =>
            createInstance({
                url: `/duty-annotations/timing`,
                method: 'POST',
                data,
            }),
        alertOnError: true,
    })

    const handleCreateTimingAnnotationAsync = (
        dutyCode: string,
        tripNumber: string,
        runNumber: string,
        route: string,
        identifier: string,
        timingContextType?: 'Departure' | 'Arrival',
        departureTime?: string,
        serviceNotOperated?: boolean
    ): Promise<ControlSheetAnnotationDTO> =>
        createTimingAnnotationMutation.mutateAsync({
            dutyCode,
            tripNumber,
            runNumber,
            route,
            identifier,
            timingContextType,
            departureTime,
            serviceNotOperated,
        })

    return {
        handleCreateTimingAnnotationAsync,
        isPending: createTimingAnnotationMutation.isPending,
        data: createTimingAnnotationMutation.data,
        error: createTimingAnnotationMutation.error,
    }
}
